//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: {},
  data() {
    return {
      canImg: "",
      shareMaskShow: false,
      shareImg: "",
      shareType: 0,
      wzjShow: false
    };
  },
  watch: {
    //观察Vue实例上的数据变动
  },
  computed: {
    //DOM加载后马上执行能够缓存数据
  },
  methods: {
    //触发事件
    lotteryTap() {
      let data = {
        openid: this.local.openid
      };
      this.lottery(data);
    },
    uploadTap() {
      this.$router.push({ name: "upload" });
    },
    canvas(_user, _name) {
      var winWidth = window.innerWidth;
      var winHeight = window.innerHeight;
      var canvas = document.getElementById("cvs");
      var ctx = canvas.getContext("2d");
      var canvasWidth = canvas.offsetWidth;
      var canvasHeight = canvas.offsetHeight;
      canvas.width = 750;
      canvas.height = 1204;
      canvas.style.width = "375px";
      canvas.style.height = "667px";
      var user = new Image();
      var logo = new Image();
      var user_name = new Image();
      var title = new Image();
      var rwm = new Image();
      var name = _name;

      if (name.length > 7) {
        name = name.substring(0, 7) + "...";
      }
      var dost = "本年度拍过最烂的照片";
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, 750, 1334);
      user.src = _user;
      user.crossOrigin = "Anonymous";
      user.setAttribute("crossOrigin", "Anonymous");

      user.onload = () => {
        ctx.drawImage(user, 0, 0, 750, 750);

        logo.src = "http://meizu.qianhai12315.com/m8/static/img/logo.png";
        logo.crossOrigin = "Anonymous";
        logo.setAttribute("crossOrigin", "Anonymous");
        logo.onload = () => {
          ctx.drawImage(logo, 40, 40, 138, 26);
          user_name.src =
            "http://meizu.qianhai12315.com/m8/static/img/name_bj.png";
          user_name.crossOrigin = "Anonymous";
          user_name.setAttribute("crossOrigin", "Anonymous");
          user_name.onload = () => {
            ctx.drawImage(user_name, 0, 660, 750, 92);
            ctx.font = "30px 微软雅黑";
            ctx.fillStyle = "#fff";
            ctx.textAlign = "left";

            ctx.fillText(name, 40, 720);

            ctx.font = "30px 微软雅黑";
            ctx.fillStyle = "#fff";
            ctx.textAlign = "left";
            ctx.fillText(dost, 50 + ctx.measureText(name).width, 720);

            title.src =
              "http://meizu.qianhai12315.com/m8/static/img/sc_title.png";
            title.crossOrigin = "Anonymous";
            title.setAttribute("crossOrigin", "Anonymous");
            title.onload = () => {
              ctx.drawImage(title, 122, 810, 518, 98);

              rwm.src = "./static/img/rwm.png";
              rwm.crossOrigin = "Anonymous";
              rwm.setAttribute("crossOrigin", "Anonymous");
              rwm.onload = () => {
                ctx.drawImage(rwm, 250, 960, 250, 140);

                var imgUrl = canvas.toDataURL("image/jpeg");
                this.canImg = imgUrl;

                var fg = imgUrl.split(",");
                let data = {
                  file: fg[1],
                  openid: this.local.openid
                };
                // this.uploadImg(data);
                this.$vux.loading.hide();
                this.$vux.toast.show({
                  text: "可以保存啦~",
                  time: "2000",
                  width: "2.5rem",
                  position: "middle",
                  type: "success"
                });
              };
            };
          };
        };
      };
    },
    uploadImg(data) {
      this.request(
        "/user/upload_img",
        data,
        "POST",
        "application/x-www-form-urlencoded"
      )
        .then(res => {
          console.log(res);
          if (res.data.ret == 200) {
            this.shareImg = res.data.data;
            console.log("上传图片成功");
            this.$vux.toast.show({
              text: "可以保存啦~",
              time: "2000",
              width: "2.5rem",
              position: "middle",
              type: "success"
            });

            var text = [
              `${this.local.nickname}本年度拍过的最烂照片，真是惊呆了！`,
              "魅族Note8 国民拍照手机，10月25日拯救你的烂照片。",
              `${
                this.local.nickname
              }晒了他半年度拍过的最烂照片，大家快来强势围观！`,
              `论拍烂照片，${
                this.local.nickname
              }至今还没怕过谁，不信？那你点进来比比。`,
              "照片拍不好，是你没有用魅族 Note8 国民拍照手机。"
            ];
            var _desc = Math.floor(Math.random() * text.length);
            // 微信分享
            console.log("微信分享");
            var appid = this.Global.appid;
            var wechat = new Wechat(appid);

            this.$vux.loading.hide();
            wechat.config({
              debug: false,
              jsApiList: [
                "checkJsApi",
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareWeibo"
              ]
            });
            let _name = encodeURIComponent(this.local.nickname);
            // console.log("缓存" + _name);
            var share_url =
              location.href.split("#")[0] +
              "#" +
              this.$route.path +
              "?state=1&id=" +
              res.data.data.id;

            console.log("参数解析");

            console.log(
              location.href.split("#")[0] + "#" + location.href.split("#")[1]
            );
            console.log("参数解析" + share_url);

            var title = "10.25 国民拍照手机魅族 Note8 新品发布会";
            var desc = text[_desc];
            wechat.shareFriend(
              {
                appmessageTitle: title,
                appmessageDesc: desc,
                link: share_url,
                imgUrl:
                  "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
              },
              () => {
                // fiboSDK.share("friend");
                console.log("分享成功");
                let data = {
                  openid: this.local.openid
                };
                this.save(data);
              },
              function() {
                console.log("cancel");
              }
            );

            wechat.shareTimeline(
              {
                timelineTitle: desc,
                link: share_url,
                imgUrl:
                  "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
              },
              () => {
                let data = {
                  openid: this.local.openid
                };
                this.save(data);
              },
              function() {}
            );
          } else {
            this.$vux.toast.show({
              text: res.data.error,
              time: "2000",
              width: "5rem",
              position: "middle",
              type: "text"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$vux.toast.show({
            text: err,
            time: "2000",
            width: "5rem",
            position: "middle",
            type: "text"
          });
        });
    },

    save(data) {
      this.requestGet(
        "/share/save",
        data,
        "GET",
        "application/x-www-form-urlencoded"
      )
        .then(res => {
          console.log(res);
          if (res.data.ret == 200) {
            console.log("恭喜你获得抽奖机会");
            this.$vux.toast.show({
              text: "恭喜你获得抽奖机会",
              time: "2000",
              width: "3.5rem",
              position: "middle",
              type: "text"
            });
          } else {
            this.$vux.toast.show({
              text: res.data.error,
              time: "2000",
              width: "5rem",
              position: "middle",
              type: "text"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$vux.toast.show({
            text: err,
            time: "2000",
            width: "5rem",
            position: "middle",
            type: "text"
          });
        });
    },
    lottery(data) {
      this.request(
        "/prize/lottery",
        data,
        "POST",
        "application/x-www-form-urlencoded"
      )
        .then(res => {
          console.log(res);
          if (res.data.ret == 200) {
            console.log("抽奖成功");
            // res.data.data.bingo = true
            if (res.data.data.bingo) {
              console.log("中奖");
              this.$router.push({
                name: "data",
                params: {
                  id: res.data.data.prize.id,
                  level: res.data.data.prize.level
                }
              });
            } else {
              console.log("未中奖");
              this.wzjShow = true;
            }
          } else {
            this.$vux.toast.show({
              text: res.data.error,
              time: "2000",
              width: "5rem",
              position: "middle",
              type: "text"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$vux.toast.show({
            text: err,
            time: "2000",
            width: "5rem",
            position: "middle",
            type: "text"
          });
        });
    },
    getImage(data) {
      this.request(
        "/user/get_image",
        data,
        "POST",
        "application/x-www-form-urlencoded"
      )
        .then(res => {
          console.log(res);
          if (res.data.ret == 200) {
            console.log("获取图片地址成功");
            this.canImg = res.data.data.image_url;
          } else {
            this.$vux.toast.show({
              text: res.data.error,
              time: "2000",
              width: "5rem",
              position: "middle",
              type: "text"
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$vux.toast.show({
            text: err,
            time: "2000",
            width: "5rem",
            position: "middle",
            type: "text"
          });
        });
    }
  },
  created() {
    //页面渲染前调用
  },
  mounted() {
    //页面渲染完成调用

    if (this.$route.query.state == 1) {
      console.log("分享状态");
      this.shareType = 1;
      console.log("分享id" + this.$route.query.id);
      this.canvas(this.Global.userImg, this.$route.query.ncName);
      let data = {
        id: this.$route.query.id
      };
      this.getImage(data);

      var text = [
        `${this.local.nickname}本年度拍过的最烂照片，真是惊呆了！`,
        "魅族Note8 国民拍照手机，10月25日拯救你的烂照片。",
        `${this.local.nickname}晒了他半年度拍过的最烂照片，大家快来强势围观！`,
        `论拍烂照片，${
          this.local.nickname
        }至今还没怕过谁，不信？那你点进来比比。`,
        "照片拍不好，是你没有用魅族 Note8 国民拍照手机。"
      ];
      var _desc = Math.floor(Math.random() * text.length);
      // 微信分享
      console.log("微信分享");
      var appid = this.Global.appid;
      var wechat = new Wechat(appid);

      this.$vux.loading.hide();
      wechat.config({
        debug: false,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo"
        ]
      });
      let _name = encodeURIComponent(this.local.nickname);
      // console.log("缓存" + _name);
      var share_url =
        location.href.split("#")[0] +
        "#" +
        this.$route.path +
        "?state=1&id=" +
        this.$route.query.id;

      console.log("参数解析");

      console.log(
        location.href.split("#")[0] + "#" + location.href.split("#")[1]
      );
      console.log("参数解析" + share_url);

      var title = "10.25 国民拍照手机魅族 Note8 新品发布会";
      var desc = text[_desc];
      wechat.shareFriend(
        {
          appmessageTitle: title,
          appmessageDesc: desc,
          link: share_url,
          imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
        },
        () => {
          // fiboSDK.share("friend");
          console.log("分享成功");
          let data = {
            openid: this.local.openid
          };
          this.save(data);
        },
        function() {
          console.log("cancel");
        }
      );

      wechat.shareTimeline(
        {
          timelineTitle: desc,
          link: share_url,
          imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
        },
        () => {
          let data = {
            openid: this.local.openid
          };
          this.save(data);
        },
        function() {}
      );
    } else {
      this.canvas(this.Global.userImg, this.$route.query.ncName);
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/posters.vue